export class Cadre {
  ID: number;
  CadreName: string;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  IsDelivery: boolean;
}
